import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <span className="logo-symbol small">
            <img src="/images/logo.jpg" alt="Calowry Logo" />
          </span>
          <span className="footer-text">Calowry Inc.</span>
        </div>
        <p className="footer-meta">
          © {new Date().getFullYear()} Calowry Inc. All rights reserved.
        </p>
        <p className="footer-meta">
          No cookies. No tracking pixels. Just chocolate technology.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
